import { render, staticRenderFns } from "./cModalColor.vue?vue&type=template&id=ae5b9a8e"
import script from "./cModalColor.vue?vue&type=script&lang=js"
export * from "./cModalColor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports